import { PageErrorType } from "../state/types";

/**
 * Machine-readable reasons sent by the queue server in the body of a failed
 * `GET /stagedoor/configs`. Keep these values in step with
 * `src/stageDoor/errorReasons.ts` in cq-queue-server.
 */
export const StageDoorErrorReason = {
  InvalidParameters: "invalid_parameters",
  InvitationCancelled: "invitation_cancelled",
  InvitationInUse: "invitation_in_use",
  InvitationNotFound: "invitation_not_found",
  ServerError: "server_error",
} as const;

const REASON_TO_ERROR_TYPE: { [reason: string]: PageErrorType } = {
  [StageDoorErrorReason.InvitationCancelled]: PageErrorType.InvitationCancelled,
  [StageDoorErrorReason.InvitationInUse]: PageErrorType.InvitationInUse,
  [StageDoorErrorReason.InvitationNotFound]: PageErrorType.InvitationInvalid,
};

/**
 * Works out which fault occurred.
 *
 * The reason comes first. A cancelled invitation and a session that is in use
 * both return 403, so the status code alone made the page report "in use" for
 * an invitation that a producer had cancelled. The status code stays as a
 * fallback for a server that is older than this page.
 *
 * Returns undefined when the fault is not one the page has copy for. The caller
 * then shows the raw error message.
 */
export const getPageErrorType = (
  reason?: string,
  status?: number
): PageErrorType | undefined => {
  if (reason && reason in REASON_TO_ERROR_TYPE) {
    return REASON_TO_ERROR_TYPE[reason];
  }

  if (status === 403) {
    return PageErrorType.InvitationInUse;
  }

  if (status === 404) {
    return PageErrorType.InvitationInvalid;
  }

  return undefined;
};
